import request from '@/axios/request.js'

export const DESC_GEN_NONE = '__NONE__'

export function getSeriesOptions() {
    return request({
        url: '/api/price-maps/series-options',
        method: 'get'
    })
}

export function getAttrTree(categoryId) {
    return request({
        url: '/api/price-maps/attr-tree',
        method: 'get',
        params: { categoryId }
    })
}

export function resolveDescGen(categoryId, selected) {
    return request({
        url: '/api/desc-gen/' + categoryId + '/resolve',
        method: 'post',
        data: { selected: selected || {} }
    })
}